import { apiRequest, handleCall } from 'syft-acp-core/api/call'

export const fetchVenueCategories = ({ employerID }: { employerID: number }) =>
  new Promise((resolve, reject) => {
    const req = apiRequest({ path: `/employers/${employerID}/venue_categories` })
    handleCall(req, resolve, reject, true, { employerID })
  })
